export function isAdmin(user) {
  return Boolean(user?.is_admin);
}

export function isTeamLeader(user) {
  if (!user) return false;
  return Boolean(user.is_team_leader) || Number(user.management_id) === 1;
}

export function isHr(user) {
  if (!user) return false;
  return Boolean(user.is_hr) || Number(user.management_id) === 2;
}

export function canManageUsers(user) {
  if (!user) return false;
  return isAdmin(user) || isTeamLeader(user) || isHr(user);
}

export function canCreateUser(user) {
  return canManageUsers(user);
}

export function canEditUser(actor, targetUserId) {
  if (!actor) return false;
  if (canManageUsers(actor)) return true;
  return Number(actor.id) === Number(targetUserId);
}

export function canDeleteUser(actor, targetUserId) {
  if (!actor) return false;
  if (!canManageUsers(actor)) return false;
  return Number(actor.id) !== Number(targetUserId);
}

/** Keep admin-only for sensitive role flags (e.g. is_admin toggle). */
export function canManageUserPrivileges(user) {
  return isAdmin(user);
}

/** Bureau, department, and management — not editable on own profile. */
export function canEditUserOrgAssignment(actor, targetUserId) {
  if (!actor || !canManageUsers(actor)) return false;
  if (targetUserId != null && Number(actor.id) === Number(targetUserId)) return false;
  return true;
}
